import iconBook from "../../../assets/icons/ic-book.png";
import defaultMenuImage from "./../../../assets/images/default-images-empty.png";
import "./index.scss";
import truncate from "lodash/truncate";
import utils from "../../../core/utils";
import * as actions from "./../../../modules/user/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ReturnTopButton from "../../shared/top-button";
import moment from "moment-timezone";
import React, { Component } from "react";
import cloneDeep from "lodash/cloneDeep";
import { ButtonStyled, ColorWrapper } from "../homes/containers/common-styled";
import {
  CITY_BOOKING,
  COUNTER_TABLE,
  COUNTER_TABLE_MENU,
  GOURMET,
  STANDARD_TABLE_MENU,
  ALL_TABLE_MENU,
} from "../../../constants/app";
// import ScrollTopBtn from "./../../shared/scroll-button";

//eslint-disable-next-line
Number.prototype.format = function (n, x, s, c) {
  //eslint-disable-next-line
  var re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\D" : "$") + ")",
    num = this.toFixed(Math.max(0, ~~n));

  return (c ? num.replace(".", c) : num).replace(
    new RegExp(re, "g"),
    "$&" + (s || ",")
  );
};
class Content extends Component {
  constructor(props) {
    super(props);
    this.isGourmet = props.user.shopDetail.category_type === GOURMET;
    this.isCityBooking = props.user.shopDetail.city_name === CITY_BOOKING;
    this.dispatch = props.dispatchActions;
    this.pageColor = props.user.shopDetail.color || "#fd666c";

    this.state = {
      shopId: props.match.params.id,
      listMenu: [],
      listChosenMenuId: [],
      listChosenMenu: [],
      listDiscount: [],
      total:
        JSON.parse(localStorage.getItem(`${props.match.params.id}`))?.total ||
        "",
      discount:
        JSON.parse(localStorage.getItem(`${props.match.params.id}`))
          ?.discount || "",
      renderData: [],
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    const listMenuMap = this.renderListMenu();
    this.setState({ renderData: listMenuMap });
  }

  renderListMenu = () => {
    const {
      shopMenus,
      shopDiscounts,
      shopStaffs,
      userBookingData: { chosenStaff, bookingType },
    } = this.props.user;

    let filterdShopMenu = cloneDeep(shopMenus);

    if (chosenStaff) {
      const staffMenus = shopStaffs.find((s) => s.id === chosenStaff).menus;
      filterdShopMenu = staffMenus;
    }

    const renderData = filterdShopMenu
      .filter((menu) => {
        if (!this.isGourmet || !this.isCityBooking) return true;

        if (bookingType === COUNTER_TABLE) {
          return (
            menu.type === COUNTER_TABLE_MENU || menu.type === ALL_TABLE_MENU
          );
        } else {
          return (
            menu.type === STANDARD_TABLE_MENU || menu.type === ALL_TABLE_MENU
          );
        }
      })
      .map((item) => {
        const itemClone = cloneDeep(item);
        const discount = shopDiscounts.find((d) => d.id === itemClone.discount);
        if (discount) {
          let validTo = shopDiscounts.find(
            (d) => d.id === itemClone.discount
          )?.valid_to;

          const now = moment().format("YYYY-MM-DDTHH:mm");

          if (moment(now).isSameOrBefore(validTo)) {
            itemClone.showDiscount = true;
          } else {
            itemClone.showDiscount = false;
          }
        } else {
          itemClone.showDiscount = false;
        }

        return itemClone;
      });

    return renderData;
  };

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  isValidDiscount = (discount) => {
    let chosenTime = this.props.user.userBookingData.chosenTime;
    if (this.isGourmet) {
      const { year, month, date } =
        this.props.user.userBookingData.selectedDate;
      chosenTime = `${year}-${month}-${date} ${chosenTime}`;
      const selectMoment = moment(chosenTime, "YYYY-MM-DD HH:mm");

      const validFrom = moment(discount.valid_from);
      const validTo = moment(discount.valid_to);

      const isDateInRange =
        selectMoment.isSameOrAfter(validFrom, "day") &&
        selectMoment.isSameOrBefore(validTo, "day");

      const isTimeInRange =
        selectMoment.format("HH:mm") >= validFrom.format("HH:mm") &&
        selectMoment.format("HH:mm") < validTo.format("HH:mm");

      return isDateInRange && isTimeInRange;
    } else {
      return (
        discount &&
        moment(
          moment(discount.valid_to).format("YYYY-MM-DD HH:mm")
        ).isSameOrAfter(
          moment(chosenTime || new Date()).format("YYYY-MM-DD HH:mm")
        ) &&
        moment(
          moment(discount.valid_from).format("YYYY-MM-DD HH:mm")
        ).isSameOrBefore(
          moment(chosenTime || new Date()).format("YYYY-MM-DD HH:mm")
        )
      );
    }
  };

  removeMenu = (menu) => {
    const listChosen = this.props.user.userBookingData.chosenMenu.split(",");
    const index = listChosen.findIndex((item) => +item === menu.id);
    listChosen.splice(index, 1);
    const totalMoney = listChosen
      .map((chosen) =>
        this.props.user.shopMenus.find((menu) => +chosen === menu.id)
      )
      .reduce((acc, curr) => {
        return (acc += Number(curr.price));
      }, 0);

    const totalDuration = listChosen
      .map((chosen) =>
        this.props.user.shopMenus.find((menu) => +chosen === menu.id)
      )
      .reduce((acc, curr) => {
        return (acc += Number(curr.duration));
      }, 0);

    let totalDiscount = listChosen
      .map((chosen) =>
        this.props.user.shopMenus.find((menu) => +chosen === menu.id)
      )
      .reduce((acc, curr) => {
        const discount = this.props.user.shopDiscounts.find(
          (item) => curr.discount === item.id
        );

        let amount = acc;
        if (discount && this.isValidDiscount(discount)) {
          if (discount.type === "Percentage") {
            amount += (+discount.value * +curr.price) / 100;
          } else {
            amount += +discount.value;
          }
        }
        return amount;
      }, 0);

    const userBookingData = {
      ...this.props.user.userBookingData,
      total: totalMoney,
      duration: totalDuration,
      discount: totalDiscount,
      chosenMenu: listChosen.join(","),
    };

    this.dispatch.setUserBookingData({
      key: this.state.shopId,
      value: userBookingData,
    });
  };

  choseMenu = (menu) => {
    let listChosen;
    if (!this.props.user.userBookingData.chosenMenu || this.isGourmet) {
      listChosen = [menu.id];
    } else {
      listChosen = this.props.user.userBookingData.chosenMenu.split(",");
      if (listChosen.find((id) => menu.id === +id)) {
        return;
      }
      listChosen.push(menu.id);
    }

    const totalMoney = listChosen
      .map((chosen) =>
        this.props.user.shopMenus.find((menu) => +chosen === menu.id)
      )
      .reduce((acc, curr) => {
        return (acc += Number(curr.price));
      }, 0);

    const totalDuration = listChosen
      .map((chosen) =>
        this.props.user.shopMenus.find((menu) => +chosen === menu.id)
      )
      .reduce((acc, curr) => {
        return (acc += Number(curr.duration));
      }, 0);
    let other = null;
    let totalDiscount = listChosen
      .map((chosen) =>
        this.props.user.shopMenus.find((menu) => +chosen === menu.id)
      )
      .reduce((acc, curr) => {
        const discount = this.props.user.shopDiscounts.find(
          (item) => curr.discount === item.id
        );

        let amount = acc;
        if (discount && this.isValidDiscount(discount)) {
          if (discount.type === "Percentage") {
            amount += (+discount.value * +curr.price) / 100;
          } else if (discount.type === "Other") {
            other = discount;
          } else {
            amount += +discount.value;
          }
        }
        return amount;
      }, 0);

    const userBookingData = {
      ...this.props.user.userBookingData,
      total: totalMoney,
      discount: totalDiscount,
      duration: totalDuration,
      chosenMenu: listChosen.join(","),
      otherDiscount: other,
    };

    this.dispatch.setUserBookingData({
      key: this.state.shopId,
      value: userBookingData,
    });
  };

  renderDiscount = (shopDiscounts, menu) => {
    if (!menu.showDiscount) return null;
    let value = "";
    const discount = shopDiscounts.find(
      (discount) => discount.id === menu.discount
    );
    if (discount.type === "Other") {
      value = discount.value_other;
    } else {
      value = `${discount.value} ${discount.type === "Fixed" ? "円" : "%"}`;
    }
    return (
      <div className="user-menus__discount-info">
        <ColorWrapper $color="#fc3c60" $isColor className="mb-2">
          ※ 割引：
          {discount.name} ({value})
        </ColorWrapper>
        <ColorWrapper $color="#fc3c60" $isColor className="mb-2">
          ({moment(discount.valid_from).format("YYYY/MM/DD HH:mm")} -{" "}
          {moment(discount.valid_to).format("YYYY/MM/DD HH:mm")})
        </ColorWrapper>
      </div>
    );
  };

  choseSpecialMenu = () => {
    const { special_menu, chosenMenu } = this.props.user.userBookingData;
    let value = {
      special_menu: !special_menu,
    };
    if (!special_menu) {
      if (chosenMenu) {
        value["chosenMenu"] = "";
        value["total"] = 0;
        value["discount"] = 0;
        value["duration"] = 0;
      }
    }

    this.dispatch.setUserBookingData({
      key: this.state.shopId,
      value: {
        ...this.props.user.userBookingData,
        ...value,
      },
    });
  };

  gotoTop = () => {
    this.props.history.push(`/${this.props.match.params.id}/booking`);
  };

  render() {
    const { gotoTop, choseMenu, removeMenu, renderDiscount, choseSpecialMenu } =
      this;
    const { renderData } = this.state;
    const { shopMenus, userBookingData, shopDiscounts } = this.props.user;
    const { total, discount, duration, special_menu, otherDiscount } =
      this.props.user.userBookingData;
    let chosenMenu = [];
    if (userBookingData.chosenMenu) {
      chosenMenu = userBookingData.chosenMenu
        .split(",")
        .map((item) => shopMenus.find((menu) => menu.id === +item));
    }

    return (
      <>
        <div
          id="user-booking-menus"
          className="user-staffs user-menus fade-out"
        >
          <div className="user-menus__wrapper">
            <div className="user-staffs__ttl user-menus__ttl">
              <section>
                <figure>
                  <img src={iconBook} alt="cippo-booking"></img>
                </figure>
                <p>{this.isGourmet ? "コース" : "メニュー"}を選択する</p>
              </section>
              <span className="user-menus__btn-return-top" onClick={gotoTop}>
                TOPへ戻る
              </span>
            </div>
            <div className="user-menus__ctn-wrapper">
              <ul className="user-menus__list-menu">
                {this.isGourmet && this.isCityBooking && (
                  <li
                    className="user-menus__menu-info"
                    style={{
                      boxShadow: userBookingData.special_menu
                        ? `0 -1px 0 0 inset ${this.pageColor},
                          0 1px 0 0 inset ${this.pageColor},
                          1px 0 0 0 inset ${this.pageColor},
                          0 0 0 1px inset ${this.pageColor}`
                        : "",
                    }}
                  >
                    <div className="d-flex align-items-center justify-content-between">
                      <p>席だけ予約する</p>
                      <ButtonStyled
                        $color={
                          !!userBookingData.choseMenu ? "#ddd" : this.pageColor
                        }
                        $isColor
                        $isBorder
                        className="user-menus__chose-btn"
                        onClick={() => choseSpecialMenu()}
                        disabled={!!userBookingData.choseMenu}
                      >
                        選択する
                      </ButtonStyled>
                    </div>
                  </li>
                )}
                {renderData.map((item) => (
                  <li
                    key={item.id}
                    // className="user-menus__menu-info"
                    // eslint-disable-next-line react/jsx-no-duplicate-props
                    className="user-menus__menu-info"
                    style={{
                      boxShadow: chosenMenu.find((menu) => menu.id === item.id)
                        ? `0 -1px 0 0 inset ${this.pageColor},
                          0 1px 0 0 inset ${this.pageColor},
                          1px 0 0 0 inset ${this.pageColor},
                          0 0 0 1px inset ${this.pageColor}`
                        : "",
                    }}
                  >
                    <div>
                      <figure className="user-menus__menu-image">
                        <img
                          // src={item.image || defaultMenuImage}
                          src={
                            item.media_type === "image"
                              ? item.image || defaultMenuImage
                              : utils.getIdLinkYoutube(item.image)
                              ? `https://img.youtube.com/vi/${
                                  utils.getIdLinkYoutube(item.image)[1]
                                }/0.jpg`
                              : defaultMenuImage
                          }
                          alt="cippo-booking"
                        ></img>
                      </figure>
                      <div className="user-menus__menu-content">
                        <ColorWrapper
                          className="user-menus__menu-ttl"
                          $color={this.pageColor}
                          $isColor
                        >
                          {item.name}
                        </ColorWrapper>
                        <p className="user-menus__menu-desc">
                          {window._.truncate(item.detail, {
                            length: 150,
                            omission: "...",
                          })}
                        </p>
                      </div>
                      <div className="user-menus__time-and-price">
                        <div className="user-menus__time">
                          <span className="material-icons">schedule</span>
                          <p>{item.duration}分</p>
                        </div>
                        <div className="user-menus__price d-flex align-items-center">
                          ¥
                          {truncate(
                            utils.formatMoney(
                              Number(item.price),
                              0,
                              3,
                              ",",
                              "."
                            ),
                            {
                              length: 15,
                              omission: "...",
                            }
                          )}
                          {this.isGourmet &&
                            this.isCityBooking &&
                            item.includes_tax && (
                              <span className="text-muted ms-1">
                                {"(税込)"}
                              </span>
                            )}
                        </div>
                        <ButtonStyled
                          $color={
                            !!userBookingData.special_menu
                              ? "#ddd"
                              : this.pageColor
                          }
                          $isColor
                          $isBorder
                          className="user-menus__chose-btn"
                          onClick={() => choseMenu(item)}
                          disabled={!!userBookingData.special_menu}
                        >
                          選択する
                        </ButtonStyled>
                      </div>
                    </div>

                    {renderDiscount(shopDiscounts, item)}
                  </li>
                ))}
              </ul>
              <div className="user-menus__cart-and-charge">
                <section>
                  <div>
                    <div className="user-menus__total-estimate">
                      <p className="user-menus__time-estimate">
                        <span>予想時間</span>
                        <ColorWrapper
                          $color={this.pageColor}
                          $isColor
                          className="ms-auto"
                        >
                          {duration}分
                        </ColorWrapper>
                      </p>
                      <p className="user-menus__price-estimate">
                        <span>金額</span>
                        <ColorWrapper
                          $color={this.pageColor}
                          $isColor
                          className="ms-auto"
                        >
                          ¥
                          {total
                            ? utils.formatMoney(Number(total), 0, 3, ",", ".")
                            : 0}
                        </ColorWrapper>
                      </p>
                      <p className="user-menus__discount-estimate">
                        <span>割引</span>
                        <div className="ms-auto">
                          <ColorWrapper
                            $color={this.pageColor}
                            $isColor
                            className="text-end"
                          >
                            ¥
                            {discount
                              ? utils.formatMoney(
                                  Number(discount),
                                  0,
                                  3,
                                  ",",
                                  "."
                                )
                              : 0}
                          </ColorWrapper>

                          {otherDiscount && (
                            <ColorWrapper
                              $color={this.pageColor}
                              $isColor
                              className="text-end mt-1"
                            >
                              {otherDiscount.value_other}
                            </ColorWrapper>
                          )}
                        </div>
                      </p>
                    </div>
                    <p className="user-menus__money-estimate">
                      <span>見積金額</span>
                      <ColorWrapper
                        $color={this.pageColor}
                        $isColor
                        className="ms-auto"
                      >
                        ¥
                        {total
                          ? utils.formatMoney(
                              Number(total - discount),
                              0,
                              3,
                              ",",
                              "."
                            )
                          : 0}
                      </ColorWrapper>
                    </p>
                  </div>

                  <button
                    disabled={!chosenMenu.length && !special_menu}
                    className="user-menus__confirm-btn"
                    onClick={gotoTop}
                    style={{
                      backgroundColor: this.pageColor,
                    }}
                  >
                    確定
                  </button>
                </section>

                <ul className="user-menus__chosen-menus chosen-menus custom-style-scrollbar">
                  {chosenMenu.map((menu) => (
                    <li key={menu.id}>
                      <span
                        className="material-icons chosen-menus__close-btn"
                        onClick={() => removeMenu(menu)}
                      >
                        close
                      </span>
                      <ColorWrapper
                        className="chosen-menus__name"
                        $color={this.pageColor}
                        $isColor
                      >
                        {menu.name}
                      </ColorWrapper>
                      <ColorWrapper
                        className="chosen-menus__price"
                        $color={this.pageColor}
                        $isColor
                      >
                        ¥{utils.formatMoney(Number(menu.price), 0, 3, ",", ".")}
                      </ColorWrapper>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <ReturnTopButton size="large" onClick={gotoTop} />
          </div>
        </div>
        {/* <ScrollTopBtn /> */}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatchActions: bindActionCreators({ ...actions }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Content);
